// Modules
import React, { useContext } from "react";
import PropTypes from "prop-types";

// Context
import ApiContext from "../../../contexts/ApiContext";

// Assets
import "./share-buttons.scss";
import FacebookIcon from "../../../assets/img/svg/Facebook";
import LinkedInIcon from "../../../assets/img/svg/LinkedIn";
import MailIcon from "../../../assets/img/svg/MailIcon";
import WhatsappIcon from "../../../assets/img/svg/WhatsappIcon";
import TwitterIcon from "../../../assets/img/svg/TwitterIcon";

const ShareButtons = (props) => {
	const {
		clssName,
		loading,
		title,
		resume,
		id,
	} = props;
	const { isMobile, isTablet } = useContext(ApiContext);
	const currentUrl = window.location.href.includes("localhost") === true
		? `https://front-biens-bevouac.vercel.app/${id}`
		: window.location.href.split("#")[0];
	const hashTags = "bevouac,investissements,immobilier,investing,investissementlocatif";

	const handleShare = (url) => {
		window.open(
			url,
			"_blank"
		).focus();
	};

	return (
		<div className={`share-buttons-container ${clssName} ${isMobile === true || isTablet === true ? "mobile" : ""}`}>
			<h4 className="title">Partager ma fiche :</h4>
			<div className="links-container">
				<button
					onClick={() => handleShare(`https://www.facebook.com/sharer.php?u=${currentUrl}`)}
					disabled={loading}
				>
					<FacebookIcon color="var(--primary)" clssName="facebook-icon" />
				</button>
				<button
					onClick={() => handleShare(`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${title}&summary=${resume}&source="LinkedIn"`)}
					disabled={loading}
				>
					<LinkedInIcon color="var(--primary)" clssName="linkedin-icon" />
				</button>
				<button
					onClick={() => handleShare(`https://twitter.com/intent/tweet?url=${currentUrl}&text=${title}&via=&hashtags=${hashTags}`)}
					disabled={loading}
				>
					<TwitterIcon color="var(--primary)" clssName="twitter-icon" />
				</button>
				<button
					onClick={() => handleShare(`https://api.whatsapp.com/send?phone=&text=${title}%20${currentUrl}`)}
					disabled={loading}
				>
					<WhatsappIcon color="var(--primary)" clssName="whatsapp-icon" />
				</button>
				<button
					onClick={() => handleShare(`mailto:?subject=${title}&body=${resume}%0D%0A%0D%0A${currentUrl}`)}
					disabled={loading}
				>
					<MailIcon color="var(--primary)" clssName="mail-icon" />
				</button>
			</div>
		</div>
	);
};

ShareButtons.propTypes = {
	clssName: PropTypes.string,
	loading: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
	resume: PropTypes.string.isRequired,
};

ShareButtons.defaultProps = {
	clssName: "",
};

export default ShareButtons;

// Partager sur Facebook
// https://developers.facebook.com/docs/sharing/reference/share-dialog
// https://developers.facebook.com/docs/sharing/webmasters#markup
// https://developers.facebook.com/docs/sharing/reference/share-dialog
// https://developers.facebook.com/docs/javascript/reference/FB.init/v10.0
// https://developers.facebook.com/docs/javascript/quickstart
// https://developers.facebook.com/
// https://stackoverflow.com/questions/15556204/facebook-post-to-feed-to-open-in-a-window

// Facebook full URL
// `https://www.facebook.com/dialog/share?app_id=${app_id}&display=${page_type}&href=${currentUrl}&redirect_uri=${redirect_url}`

// Twitter full URL
// `https://twitter.com/intent/tweet?url=${currentUrl}&text=${title}&via=${user_id}&hashtags=${hash_tags}`

// WhatsApp full URL
// `https://api.whatsapp.com/send?phone=${phone_number}&text=${title}%20${currentUrl}`

// Mail full URL
// `mailto:${address_mail}?subject=${title}&body=${resume}%0D%0A%0D%0A${currentUrl}`


// `https://twitter.com/intent/tweet?url=https://front-biens-bevouac.vercel.app/recOdGp2AsoHOXBqV&text=T2%20de%2034m%C2%B2,%20%C3%A0%20r%C3%A9nover%20%C3%A0%20Lille&via=&hashtags=bevouac,investissements,immobilier,investing,investissementlocatif`
// `https://twitter.com/intent/tweet?url=https://front-biens-bevouac.vercel.app/recOdGp2AsoHOXBqV/#balance-sheet&text=T2%20de%2034m%C2%B2,%20%C3%A0%20r%C3%A9nover%20%C3%A0%20Lille&via=&hashtags=bevouac,investissements,immobilier,investing,investissementlocatif`